module.exports = new __parcel__URL__("thriller.1ae5dafc.jpg").toString();